export default __webpack_public_path__ + "static/t_weitemeier-96cf4c52dacc711962f42b379d20de56.jpg";